import styled, { css } from 'styled-components'

import { Typography } from '@/components/ui/typography'
import { thinScrollbar } from '@/theme/common'
import { withBorder } from '@/theme/utils'

export const OrderDetailsModalContent = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 50rem;
    background-color: ${theme.colors.white};
    border-radius: ${theme.border.radius['16']};
  `,
)

export const Header = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.space['8']};
    padding: ${theme.space['16']} ${theme.space['24']} ${withBorder(theme, 16)};
    border-bottom: ${theme.border.size['1']} solid ${theme.colors.gray300};

    & > *:nth-child(2) {
      margin-left: auto;
    }
  `,
)

export const Content = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['24']};
    padding: ${theme.space['24']};
    overflow: hidden auto;
  `,
)

export const OrderedItems = styled.ul<{ $hasVerticalScroll: boolean }>(
  ({ theme, $hasVerticalScroll }) => css`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    gap: ${theme.space['8']};
    max-height: 35rem;
    overflow: hidden auto;
    padding: ${withBorder(theme, 12)};
    border: ${theme.border.size['1']} solid ${theme.colors.gray400};
    border-radius: ${theme.border.radius['6']};
    ${thinScrollbar};

    ${
      $hasVerticalScroll &&
      css`
      padding-right: ${withBorder(theme, 6)};
    `
    }

    & > li {
      width: 100%;

      & > * {
        //max-width: 100%;
        //white-space: normal;
        //overflow-wrap: anywhere;
        //word-break: break-word;
      }

      &:not(:last-child) {
        padding-bottom: ${theme.space['8']};
        border-bottom: ${theme.border.size['1']} solid ${theme.colors.gray400};
      }
    }
  `,
)

export const OrderedItemRow = styled.div(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: 3.2rem minmax(0, 1fr);
    column-gap: ${theme.space['4']};
    width: 100%;
  `,
)

export const OrderDescription = styled(Typography)(
  () => css`
    line-height: normal;
  `,
)

export const OrderedItemDetails = styled.div(
  () => css`
    display: flex;
    flex-direction: column;
  `,
)

export const Infos = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['12']};
  `,
)
